<div class="sk-dialog">

  <!-- ── Header ─────────────────────────────────────── -->
  <header class="sk-dialog__header">
    <div class="sk-dialog__header-icon">
      <mat-icon>lock_reset</mat-icon>
    </div>
    <div class="sk-dialog__header-text">
      <span class="sk-dialog__header-title">
        {{ dynamicDataService.getTitleByFieldName('lblChangePasswordPageTitle', pageDynamicData) | translate }}
      </span>
      <span class="sk-dialog__header-sub">
        {{ 'Use a strong, unique password to protect your account' | translate }}
      </span>
    </div>
    <button class="sk-dialog__header-close" (click)="dialogRef.close({ refreshPage: false })" [attr.aria-label]="'Close' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <!-- ── Body ───────────────────────────────────────── -->
  <div class="sk-dialog__body">
    <form [formGroup]="userFormGroup" (ngSubmit)="changePassword()">

      <div class="sk-dialog__section">
        <div class="sk-dialog__section-label">
          <span class="sk-dialog__section-num">01</span>
          <span class="sk-dialog__section-title">{{ 'Password' | translate }}</span>
        </div>

        <div class="sk-dialog__grid sk-dialog__grid--single">

          <!-- Current Password -->
          <div class="sk-dialog__field">
            <label class="sk-dialog__label sk-dialog__label--required">
              {{ dynamicDataService.getTitleByFieldName('lblCurrentPassword', pageDynamicData) | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input type="password" autocomplete="off"
                [placeholder]="dynamicDataService.getTitleByFieldName('lblCurrentPassword', pageDynamicData) | translate"
                matInput formControlName="userOldPassword" />
              <mat-error *ngIf="userFormControls['userOldPassword'].errors?.['required']">
                {{ 'Required field' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- New Password -->
          <div class="sk-dialog__field">
            <label class="sk-dialog__label sk-dialog__label--required">
              {{ dynamicDataService.getTitleByFieldName('lblNewPassword', pageDynamicData) | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input formControlName="userNewPassword"
                [placeholder]="dynamicDataService.getTitleByFieldName('lblNewPassword', pageDynamicData) | translate"
                matInput [matTooltip]="'Min 8 chars with a mix of uppercase, lowercase, numbers & symbols.' | translate"
                [type]="hide ? 'password' : 'text'">
              <button mat-icon-button matSuffix type="button" (click)="hide = !hide"
                [attr.aria-label]="'Hide password' | translate" [attr.aria-pressed]="hide">
                <mat-icon class="sk-visibility-icon">{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <mat-error *ngIf="userFormControls['userNewPassword'].errors?.['required']">
                {{ 'Required field' | translate }}
              </mat-error>
              <mat-error *ngIf="userFormControls['userNewPassword'].errors?.['pattern']">
                {{ 'Weak Password' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <!-- Confirm Password -->
          <div class="sk-dialog__field">
            <label class="sk-dialog__label sk-dialog__label--required">
              {{ dynamicDataService.getTitleByFieldName('lblRetypePassword', pageDynamicData) | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input type="password" autocomplete="off"
                [placeholder]="dynamicDataService.getTitleByFieldName('lblRetypePassword', pageDynamicData) | translate"
                matInput formControlName="userConfirmPassword" />
              <mat-error *ngIf="userFormControls['userConfirmPassword'].errors?.['required']">
                {{ 'Required field' | translate }}
              </mat-error>
              <mat-error *ngIf="userFormControls['userConfirmPassword'].errors?.['mustMatch']">
                {{ 'Confirm password does not match!' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

        </div>
      </div>

    </form>
  </div>

  <!-- ── Footer ─────────────────────────────────────── -->
  <footer class="sk-dialog__footer">
    <button class="sk-dialog__btn sk-dialog__btn--ghost" type="button"
      (click)="dialogRef.close({ refreshPage: false })">
      {{ dynamicDataService.getTitleByFieldName('btnCancel', pageDynamicData) | translate }}
    </button>
    <button class="sk-dialog__btn sk-dialog__btn--primary" type="button"
      (click)="changePassword()">
      <mat-icon>save</mat-icon>
      {{ dynamicDataService.getTitleByFieldName('btnSave', pageDynamicData) | translate }}
    </button>
  </footer>

</div>
